'use client';

import { useDecisions } from '../../../hooks';
import { BazaarVoiceContextualLegacy } from './BazaarVoiceContextual.legacy';

export const BazaarVoiceContextualCommerceScript = () => {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <BazaarVoiceContextualLegacy />;
};
